<template>
    <div>
        <v-dialog
            v-model="visible"
            transition="dialog-bottom-transition"
            :overlay="false"
            scrollable
            fullscreen
        >
            <v-card>
                <v-toolbar
                    style="flex: 0 0 auto"
                    dark
                    class="primary el-dark-top-bar"
                >
                    <v-btn
                        icon
                        @click.native.stop="$emit('change', false)"
                        dark
                    >
                        <v-icon>close</v-icon>
                    </v-btn>
                    <v-toolbar-title>{{ $t(title) }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>

                <div class="el-panel-wrapper">
                    <slot></slot>
                </div>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    name: 'dialog-view',

    model: {
        event: 'change',
    },

    props: {
        value: Boolean,
        title: {
            default: 'title.details',
        },
    },

    computed: {
        visible: {
            get() {
                return this.value
            },

            set() {
                this.$nextTick(() => this.$emit('change', true))
            },
        },
    },
}
</script>
